import { Pipe, PipeTransform } from '@angular/core';
import { daysTo, dmy, inDays, phone, pln, relDateTime, when } from './vz-format';

/** Moment przeszły względnie: „dziś, 16:10”. */
@Pipe({ name: 'vzRel', standalone: true })
export class VzRelPipe implements PipeTransform {
    transform(value: string | Date | null | undefined): string {
        return value ? relDateTime(value) : '';
    }
}

/** Data bez godziny: „21.11.2026”. */
@Pipe({ name: 'vzDmy', standalone: true })
export class VzDmyPipe implements PipeTransform {
    transform(value: string | Date | null | undefined): string {
        return value ? dmy(value) : '';
    }
}

/** Kwota: „8 415,66 zł” (`decimals` = 0 dla wartości zaokrąglonych na kaflach). */
@Pipe({ name: 'vzPln', standalone: true })
export class VzPlnPipe implements PipeTransform {
    transform(value: number | null | undefined, decimals = 2): string {
        return value === null || value === undefined ? '—' : pln(value, decimals);
    }
}

/** Termin względem dziś: „za 12 dni”, „za 5 mies.”, „minęło”. */
@Pipe({ name: 'vzInDays', standalone: true })
export class VzInDaysPipe implements PipeTransform {
    transform(value: string | Date | null | undefined): string {
        return value ? inDays(daysTo(value)) : '';
    }
}

/** Telefon: „500 200 100”. */
@Pipe({ name: 'vzPhone', standalone: true })
export class VzPhonePipe implements PipeTransform {
    transform(value: string | null | undefined): string {
        return phone(value);
    }
}

/** Moment zdarzenia: „dziś, 09:40” albo sama data („27.06.2023”), gdy CRM ma tylko datę. */
@Pipe({ name: 'vzWhen', standalone: true })
export class VzWhenPipe implements PipeTransform {
    transform(value: string | Date | null | undefined): string {
        return value ? when(value) : '';
    }
}
